<template>
  <li
    :class="key + 1 != selectedStage ? '' : style.notActive"
    v-for="(stage, key) in stages"
    @click="setSelectedStage(key)"
  >
    <div style="display: flex">
      <span :class="style.headerLi" v-text="stage[0]" />
      <span :class="style.nameLi" v-text="stage[1]" />
    </div>
    <div
      :style="{
        paddingTop: stage[1] == 'Врач' && chose.doctor ? '5px' : '0'
      }"
    >
      <div
        v-if="stage[1] == 'Врач'"
        :class="style.photo"
        :style="{
          backgroundImage: `url(${getMiniPhoto(getDoctorPhoto(chose.doctor.photo), 'vrach.png')})`
        }"
      />
      <span v-if="stage[2]" v-text="stage[2]" />
    </div>
  </li>
</template>
<script lang="ts">
import style from "../StyleWidget.module.scss";
import {defineComponent} from "vue";
import {getDoctorPhoto, getMiniPhoto} from "../ScriptsWidget";
export default defineComponent({
  name: "CustomerChoice",
  data() {
    return {
      style,
      getDoctorPhoto,
      getMiniPhoto
    };
  },
  methods: {
    setSelectedStage(key: number) {
      if (key + 1 == this.selectedStage) {
        return;
      }
      this.$widgetStore.updateConsultation(false);
      if (key == 0) {
        this.chose.DoctorName = "";
        this.chose.DoctorService = "";
        this.$widgetStore.resetCalendar();
      }
      if (key <= 1) {
        if (this.navWidget == "УСЛУГИ") {
          this.chose.DoctorName = "";
        } else {
          this.chose.DoctorService = "";
        }
      }
      if (key <= 2) {
        this.$widgetStore.resetCalendar();
      }
      if (key == 0) {
        if (this.navWidget == "УСЛУГИ") {
          this.$widgetStore.setStages([this.hints["service"]]);
        } else {
          this.$widgetStore.setStages([this.hints["doctor"]]);
        }
      } else {
        this.$widgetStore.setStages(this.stages.slice(0, key));
      }
      this.$widgetStore.setSelectedStage(key + 1);
    }
  },
  computed: {
    chose() {
      return this.$widgetStore.getChose;
    },
    selectedStage() {
      return this.$widgetStore.getSelectedStage;
    },
    navWidget() {
      return this.$widgetStore.getNavWidget;
    },
    hints() {
      return this.$widgetStore.getHints;
    },
    stages() {
      return this.$widgetStore.getStages;
    }
  }
});
</script>
